import React, { Component } from 'react';

import VPin from './VPin';

class AR extends Component {
  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = {
      fetching: false, // set to true when a fetch is in progress
      idleEvent: null, // used to cancel `idle` event listener
      localGeo: false,
      myCenter: {
        lat: 51.5369444,
        lng: -0.17472222222222222
      },
      mapCenter: {
        lat: 51.5369444,
        lng: -0.17472222222222222
      },
      panning: false,
      timer: null,     // fetch timer
      fetchRange: 1000
    };
    //this.makeFirstFetch = this.makeFirstFetch.bind(this);

   // this.handleClick = this.handleClick.bind(this);
 
   // const { fetchDelay, fetchRange, lastFetch, setLastFetch, setPlaces, userHasPanned } = this.props;

/*     getNearby(this.state.mapCenter.lat, this.state.mapCenter.lng, this.state.fetchRange)
    .then(json => {
      if (json.query && json.query.pages) {
        setPlaces(json.query.pages);
      }
    })
    .catch(this.logError)
    .finally(() => {
      this.setState({
        fetching: false
      });
    }); */
  }
  alertName = () => {
    alert('Vertical-ish');
  };

  makeFirstFetch() {
    const { map, timer } = this.state;
    const { setIsFirstFetch, setUserHasPanned } = this.props;

    setIsFirstFetch(false);

    // prevent infowindows from opening
    map.addListener('click', evt => { evt.stop() });

    // if user manually pans the map, stop watching for new locations
    map.addListener('dragstart', evt => {
      clearTimeout(timer);
      setUserHasPanned(true);
      this.setState({
        idleEvent: map.addListener('idle', this.handleIdle),
        panning: true
      });
    });

    // get first set of places
    this.newNearbyPlaces(true);
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("  componentDidUpdate ")

  }
/*   static getDerivedStateFromProps(prevProps, prevState) {
    console.log("  componentDidUpdate ")
    const { fetching, localGeo, map, maps, panning, userHasPanned, watcher } = prevState;
    const { apiLoaded, geo, isFirstFetch, setUserHasPanned } = prevProps;

    // should only ever fire once, on app load
    if (isFirstFetch) {
      this.makeFirstFetch();
    }

    // start watching for location changes when the user grants
    // location access for the first time
    if (geo && !watcher && !localGeo) {
      this.setState({
        localGeo: true
      });
      setUserHasPanned(false);
      window.requestAnimationFrame(this.watch);
    }

    // this gets hit a lot, but is basically a no-op if a fetch is
    // in progress or pending
    if (localGeo && !userHasPanned && !panning && !fetching) {
      this.panToCenter();
    }
  }; */

 
  renderARPins(places) {
    const { setPlace } = this.props;
    const { setViewInfoOpen } = this.props;
    if (places === undefined) 
      return
    const pins = places.map(place => {
      const { pageid, coordinates, thumbnail } = place;
      let thumb;
      if (thumbnail && thumbnail.source) {
        thumb = thumbnail.source;
      }
      if (coordinates.length > 0) {
        let { lat, lon } = coordinates[0];
        return (
          <VPin key={ pageid }
               thumb={ thumb }
               lat={ lat }
               lng={ lon }
               setPlace={ setPlace }
               setViewInfoOpen={ setViewInfoOpen }
               { ...place }
          />
        );
      }
      else {
        return null;
      }
    });
    return pins;
  };

  render() {
    const {  places } = this.props;

    return (

        <a-scene vr-mode-ui='enabled: false' arjs='sourceType: webcam; videoTexture: true; debugUIEnabled: true' renderer='antialias: true; alpha: true'>
          <a-camera locationfinder gps-new-camera='gpsMinDistance: 5; simulateLatitude: 51.515595; simulateLongitude: -0.092255;'></a-camera>
          { this.renderARPins(places) }

        </a-scene>

    );
  }


};

export default AR;
